import { Injectable } from "@angular/core";
import { Adapter } from "../adapter";

export class LMSProfile {
    constructor(
      public first_name: string,
      public last_name: string,
      public email: string,
      public country: string,
      public years_tattooing: number,
      public instagram: string,
      public website: string,
      public id_number: string,
      public newsletter_subscribed: boolean,
      public favourited_lesson: number[],
      public favourited_topic: number[],
      public completed_lesson: number[],
      public completed_topic: number[],
      public review_lesson: number[],
      public review_topic: number[],
      public enrollments: [],
      public avatar: string,
      public text_language: string,
      public audio_language: string
    ) {}
  }

@Injectable({
    providedIn: "root",
})

export class LMSProfileAdapter implements Adapter<LMSProfile> {
    adapt(item: any): LMSProfile {
        return new LMSProfile(item.first_name, item.last_name, item.email, item.country, item.years_tattooing, item.instagram, item.website, item.id_number, item.newsletter_subscribed, item.favourited_lesson, item.favourited_topic, item.completed_lesson, item.completed_topic, item.review_lesson, item.review_topic, item.enrollments, item.avatar, item.text_language, item.audio_language);
    }
}